var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EnumType } from 'json-to-graphql-query';
import fetch from 'cross-fetch';
import { subgraphRequest } from '../../utils';
export var author = 'ChaituVR';
export var version = '0.1.0';
var getJWT = function (dfuseApiKey) { return __awaiter(void 0, void 0, void 0, function () {
    var rawResponse, content;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch('https://auth.dfuse.io/v1/auth/issue', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ api_key: dfuseApiKey })
                })];
            case 1:
                rawResponse = _a.sent();
                return [4 /*yield*/, rawResponse.json()];
            case 2:
                content = _a.sent();
                return [2 /*return*/, content.token];
        }
    });
}); };
export function strategy(space, network, provider, addresses, options, snapshot) {
    return __awaiter(this, void 0, void 0, function () {
        var apiLimit, data, query, dfuseJWT;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiLimit = 300;
                    data = [];
                    query = Object.fromEntries(addresses.map(function (address) { return [
                        "_" + address,
                        {
                            __aliasFor: 'searchTransactions',
                            __args: {
                                indexName: new EnumType('CALLS'),
                                query: "(from:" + address + " OR to:" + address + ")",
                                sort: new EnumType('ASC'),
                                limit: 1
                            },
                            edges: {
                                block: {
                                    header: {
                                        timestamp: true
                                    },
                                    number: true
                                },
                                node: {
                                    from: true,
                                    to: true
                                }
                            }
                        }
                    ]; }));
                    return [4 /*yield*/, getJWT(options.dfuseApiKey || 'web_f527db575a38dd11c5b686d7da54d371')];
                case 1:
                    dfuseJWT = _a.sent();
                    return [4 /*yield*/, subgraphRequest('https://mainnet.eth.dfuse.io/graphql', query, {
                            headers: {
                                Authorization: "Bearer " + dfuseJWT
                            }
                        })];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, Object.fromEntries(Object.values(data).map(function (value, i) { return [
                            addresses[i],
                            (function () {
                                var _a, _b, _c;
                                var today = new Date().getTime();
                                var firstTransaction = ((_c = (_b = (_a = value.edges[0]) === null || _a === void 0 ? void 0 : _a.block) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.timestamp) || today;
                                var diffInSeconds = Math.abs(firstTransaction - today);
                                var walletAgeInDays = Math.floor(diffInSeconds / 1000 / 60 / 60 / 24);
                                return walletAgeInDays;
                            })()
                        ]; }))];
            }
        });
    });
}
